import { motion } from 'framer-motion';

export default function AnimatedEyebrow({
  children,
  className = '',
  surfaceClassName = '',
  textClassName = '',
  borderClassName = '',
  dotClassName = '',
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className={`flex items-center ${className}`.trim()}
    >
      <div className={`relative rounded-full border border-[var(--dash-main)] ${borderClassName}`.trim()}>
        <div className={`relative flex items-center gap-3 rounded-full bg-[var(--dash-black)] px-6 py-2 ${surfaceClassName}`.trim()}>
          <span className={`flex h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--dash-main)] shadow-[0_0_8px_var(--dash-main)] ${dotClassName}`.trim()} />
          <p className={`mr-[-0.5em] whitespace-nowrap text-[10px] font-[700] uppercase tracking-[0.5em] text-white/90 ${textClassName}`.trim()}>{children}</p>
        </div>
      </div>
    </motion.div>
  );
}
